import React from 'react'
import {
  Typography,
  Box
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  Search as SearchOffIcon,
  TableChart as TableIcon
} from '@mui/icons-material'

interface EmptyStateProps {
  message?: string
  icon?: React.ReactNode
  children?: React.ReactNode
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No se encontraron resultados',
  icon,
  children
}) => {
  const styles = useStyles()

  const renderIcon = () => {
    if (icon && React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        className: styles.icon
      })
    }

    return message.toLowerCase().includes('busqueda') ||
      message.toLowerCase().includes('criterios') ? (
      <SearchOffIcon className={styles.icon} />
    ) : (
      <TableIcon className={styles.icon} />
    )
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        {renderIcon()}
        <Typography variant='h6' className={styles.message}>
          {message}
        </Typography>
        {children && <Box className={styles.children}>{children}</Box>}
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.grey[50]
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '400px'
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2)
  },
  message: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(2),
    fontWeight: 400
  },
  children: {
    marginTop: theme.spacing(1)
  }
}))
